module.exports = __webpack_public_path__ + "static/media/ic-fuel@3x.5f3f3471.png";